import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { User, ArrowRight } from 'lucide-react';

const FALLBACK_POSTS = [
  {
    id: 1,
    title: "Market Manipulation 5.5 Billion Loss? MANTRA Chain's 90% $OM Collapse in April 2025",
    excerpt: 'MantraChain, which had launched their official token OM, was performing amazingly well. But suddenly, everything changed — from $9.17 on February 23, 2025, the token crashed over 90%, hitting a low of $0.37 on April 13, 2025.',
    author: 'Piyush Shukla',
    date: 'May 15, 2025',
    category: 'Security',
    image: 'https://miro.medium.com/v2/resize:fit:1100/format:webp/1*pjlznR7wcZOJZPDRQZ68tg.png',
    url: 'https://blog.safeedges.in/'
  },
  {
    id: 2,
    title: 'ByBit hack 1.4 billion exploit',
    excerpt: 'The ByBit hack is the largest crypto exchange hack of all time. 1.4 billion dollars stolen..',
    author: 'Piyush Shukla',
    date: 'May 15, 2025',
    category: 'Security',
    image: 'https://miro.medium.com/v2/resize:fit:1100/format:webp/1*uEIKvYUeM3jBy_wiw9SFQg.png',
    url: 'https://blog.safeedges.in/'
  },
  {
    id: 3,
    title: 'Zklend Hack Analysis',
    excerpt: 'On February 12, 2025, zkLend (@zkLend), a money-market protocol on Starknet, suffered an exploit that resulted in the loss of approximately $9.5',
    author: 'Piyush Shukla',
    date: 'Feb, 2025',
    category: 'Research',
    image: 'https://miro.medium.com/v2/resize:fit:1100/format:webp/1*EmPk5j-L7LG7BU1pA9xv4w.jpeg',
    url: 'https://blog.safeedges.in/'
  },
  {
    id: 4,
    title: 'Ionic Money $8.5 million Exploit : Hack Analysis',
    excerpt: 'Ionic Money, freshly rebranded from Midas after suffering two prior exploits, has fallen victim to yet another DeFi attack',
    author: 'Piyush shukla',
    date: 'Feb, 2025',
    category: 'Product',
    image: 'https://miro.medium.com/v2/resize:fit:1100/format:webp/1*GsI2NIBqAM55lp1JbVJndA.jpeg',
    url: 'https://blog.safeedges.in/'
  },
  {
    id: 5,
    title: 'Fees on Fuel Ignition| Mastering Fuel Network Gas Dynamics',
    excerpt: 'The Fuel ignition process introduces various fees and costs essential for utilizing the permissionless network. ',
    author: 'Piyush shukla',
    date: 'Jan, 2025',
    category: 'Product',
    image: 'https://miro.medium.com/v2/resize:fit:4800/format:webp/1*X1zm7-fHtRVgwJUZgNJuXQ.jpeg',
    url: 'https://blog.safeedges.in/'
  },
  {
    id: 6,
    title: 'Pike Finance Exploit $1.6 million | Hack Analysis',
    excerpt: 'Pike Finance, a cross-chain lending protocol, was exploited again in less than a week, leading to losses exceeding $1.6 million',
    author: 'Piyush shukla',
    date: 'Jan, 2025',
    category: 'Product',
    image: 'https://miro.medium.com/v2/resize:fit:1100/format:webp/1*v7egttCuTOYsMgAsS7pqUA.png',
    url: 'https://blog.safeedges.in/'
  },
  {
    id: 7,
    title: 'Understanding UTXO and Parallel Transactions in Fuel',
    excerpt: 'Among the most impactful innovations is Fuel, a high-performance Layer 2 solution for Ethereum that fully utilizes concepts like UTXO. ',
    author: 'Piyush shukla',
    date: 'Jan, 2025',
    category: 'Product',
    image: 'https://miro.medium.com/v2/resize:fit:1100/format:webp/1*IpdvDT-qsKiB99ilYQbe-g.png',
    url: 'https://blog.safeedges.in/'
  },
];

const stripHtml = (html = '') =>
  html
    .replace(/<[^>]+>/g, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&#8217;|&rsquo;/gi, "'")
    .replace(/&#8216;|&lsquo;/gi, "'")
    .replace(/&#8220;|&ldquo;/gi, '"')
    .replace(/&#8221;|&rdquo;/gi, '"')
    .replace(/&#8211;|&ndash;/gi, '–')
    .replace(/&#8212;|&mdash;/gi, '—')
    .replace(/&#038;|&amp;/gi, '&')
    .replace(/&hellip;/gi, '…')
    .replace(/&\w+;|&#\d+;/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

/* Image with a quiet gradient fallback — WordPress/Medium images occasionally 404. */
const PostImage = ({ src, alt, className = '' }) => {
  const [failed, setFailed] = useState(!src);
  return (
    <div className={`relative overflow-hidden bg-[radial-gradient(120%_120%_at_0%_0%,rgba(0,169,158,0.18),transparent_55%),linear-gradient(135deg,#0b1118,#0a0f16)] ${className}`}>
      {!failed && (
        <img
          src={src}
          alt={alt}
          loading="lazy"
          decoding="async"
          onError={() => setFailed(true)}
          className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.03]"
        />
      )}
    </div>
  );
};

const Meta = ({ post, className = '' }) => (
  <div className={`flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-[#8792a2] ${className}`}>
    <span className="font-semibold uppercase tracking-[0.1em] text-teal-300">{post.category}</span>
    <span aria-hidden="true" className="text-[#3b4452]">•</span>
    <time>{post.date}</time>
  </div>
);

const ReadMore = ({ children = 'Read article' }) => (
  <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#e6ebf1] transition-colors group-hover:text-teal-300">
    {children}
    <ArrowRight size={15} className="transition-transform duration-200 group-hover:translate-x-1" />
  </span>
);

const BlogSection = () => {
  const [blogPosts, setBlogPosts] = useState(FALLBACK_POSTS);

  // Fetch latest posts from WordPress blog (blog.safeedges.in)
  useEffect(() => {
    let isCancelled = false;

    const getFeaturedImage = (post) => {
      const media = post?._embedded?.['wp:featuredmedia']?.[0];
      return (
        media?.media_details?.sizes?.large?.source_url ||
        media?.media_details?.sizes?.medium_large?.source_url ||
        media?.source_url ||
        media?.media_details?.sizes?.medium?.source_url ||
        null
      );
    };

    const getCategory = (post) => {
      const terms = post?._embedded?.['wp:term'];
      if (!Array.isArray(terms)) return 'Article';
      const categories = terms.find(
        (group) => Array.isArray(group) && group[0]?.taxonomy === 'category'
      );
      const preferred = categories?.find(
        (c) => c.slug !== 'blog' && c.slug !== 'uncategorized'
      );
      return preferred?.name || categories?.[0]?.name || 'Article';
    };

    const normalizePosts = (items) =>
      items.slice(0, 8).map((item, idx) => {
        const excerpt = stripHtml(
          item.excerpt?.rendered || item.content?.rendered || ''
        ).slice(0, 160);
        return {
          id: item.id || item.slug || idx,
          title: stripHtml(item.title?.rendered || FALLBACK_POSTS[idx]?.title || 'Article'),
          excerpt: excerpt || FALLBACK_POSTS[idx]?.excerpt || '',
          author:
            item._embedded?.author?.[0]?.name ||
            FALLBACK_POSTS[idx]?.author ||
            'Safe Edges',
          date: new Date(item.date || Date.now()).toLocaleDateString(undefined, {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
          }),
          category: getCategory(item),
          image: getFeaturedImage(item) || FALLBACK_POSTS[idx]?.image,
          url: item.link || FALLBACK_POSTS[idx]?.url,
        };
      });

    fetch('https://blog.safeedges.in/wp-json/wp/v2/posts?per_page=8&_embed=1')
      .then((res) =>
        res.ok ? res.json() : Promise.reject(new Error('Failed to fetch WordPress posts'))
      )
      .then((data) => {
        if (isCancelled) return;
        if (Array.isArray(data) && data.length > 0) {
          setBlogPosts(normalizePosts(data));
        }
      })
      .catch(() => {
        // Silent fallback to existing static posts
      });

    return () => {
      isCancelled = true;
    };
  }, []);

  const latest = blogPosts.slice(0, 3);

  const reveal = (i = 0) => ({
    initial: { opacity: 0, y: 16 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true, margin: '-60px' },
    transition: { duration: 0.55, delay: i * 0.06, ease: [0.22, 1, 0.36, 1] },
  });

  return (
    <section className="relative overflow-hidden border-t border-white/[0.06] bg-black py-24 md:py-32">
      <div className="pointer-events-none absolute left-1/2 top-0 h-[380px] w-[min(1100px,100vw)] -translate-x-1/2 bg-[radial-gradient(50%_60%_at_50%_0%,rgba(0,169,158,0.08),transparent_70%)]" aria-hidden="true" />

      <div className="relative mx-auto max-w-6xl px-6">
        {/* Header */}
        <motion.div {...reveal()} className="mb-12 flex flex-col gap-8 md:mb-14 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="mb-5 inline-flex items-center gap-2.5 text-sm font-semibold text-teal-300">
              <span className="h-1.5 w-1.5 rounded-full bg-[#00A99E] shadow-[0_0_0_4px_rgba(0,169,158,0.18)]" aria-hidden="true" />
              Knowledge Hub
            </p>
            <h2 className="text-4xl font-semibold leading-[1.08] tracking-[-0.03em] text-white md:text-5xl">
              Latest{' '}
              <span className="bg-gradient-to-r from-teal-300 via-cyan-300 to-indigo-300 bg-clip-text text-transparent">
                Insights & Articles
              </span>
            </h2>
          </div>
          <a
            href="https://blog.safeedges.in"
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex shrink-0 items-center gap-1.5 self-start rounded-full px-5 py-2.5 text-sm font-semibold text-[#e6ebf1] ring-1 ring-white/15 transition-colors hover:bg-white/[0.06] hover:ring-white/30 md:self-auto"
          >
            Explore All Articles
            <ArrowRight size={15} className="transition-transform duration-200 group-hover:translate-x-1" />
          </a>
        </motion.div>

        {/* Three latest articles — one consistent card */}
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {latest.map((post, i) => (
            <a
              key={post.id}
              href={post.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`group flex flex-col overflow-hidden rounded-2xl bg-[#0a0f16] ring-1 ring-white/[0.08] transition-all duration-300 hover:-translate-y-1 hover:ring-white/20 hover:shadow-[0_30px_60px_-30px_rgba(0,169,158,0.35)] ${i === 2 ? 'md:hidden lg:flex' : ''}`}
            >
              <PostImage src={post.image} alt={post.title} className="aspect-[40/21] border-b border-white/[0.06]" />
              <div className="flex flex-1 flex-col p-6 sm:p-7">
                <Meta post={post} className="mb-4" />
                <h3 className="mb-3 line-clamp-2 text-xl font-semibold leading-snug tracking-[-0.02em] text-white">
                  {post.title}
                </h3>
                <p className="mb-6 line-clamp-3 flex-1 text-[15px] leading-relaxed text-[#a3acb9]">{post.excerpt}</p>
                <div className="flex items-center justify-between gap-4 border-t border-white/[0.06] pt-5">
                  <span className="flex min-w-0 items-center gap-2 text-sm text-[#8792a2]">
                    <span className="grid h-7 w-7 shrink-0 place-items-center rounded-full bg-white/[0.06] ring-1 ring-white/10">
                      <User size={13} />
                    </span>
                    <span className="truncate">{post.author}</span>
                  </span>
                  <ReadMore>Read</ReadMore>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogSection;
